/**
 * Kalendertage anzeigen — immer in der Sprache der App, nicht der des Geräts.
 *
 * `T12:00:00`: Ein Kalendertag ist kein Zeitpunkt. Mittags gelesen rutscht er
 * in keiner Zeitzone über Mitternacht in den Vortag.
 */

export type DayStyle =
  'date' | 'short' | 'shortYear' | 'long' | 'full' | 'weekdayLong' | 'weekdayShort';

const OPTIONS: Record<DayStyle, Intl.DateTimeFormatOptions> = {
  /** 13.10. */
  date: { day: '2-digit', month: '2-digit' },
  /** Di., 13.10. */
  short: { weekday: 'short', day: '2-digit', month: '2-digit' },
  /** Di., 13.10.2026 — für Angaben, die in anderen Jahren liegen (Akte). */
  shortYear: { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' },
  /** Dienstag, 13.10. */
  long: { weekday: 'long', day: '2-digit', month: '2-digit' },
  /** Dienstag, 13.10.2026 */
  full: { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' },
  /** Dienstag */
  weekdayLong: { weekday: 'long' },
  /** Di. */
  weekdayShort: { weekday: 'short' },
};

export function formatDay(isoDate: string, style: DayStyle, language: string): string {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString(language, OPTIONS[style]);
}
